import { onboardingApi } from "@/redux/apis/onboarding/onboardingApi";
import { businessApi } from "../businessApi";
import { transformBusinessDetails, transformUpdateBusinessDetails } from "./helpers";
import { GetBusinessDetailsResponse, UpdateBusinessDetailsParams, UpdateBusinessDetailsResponse } from "./types";

export const businessDetailsApi = businessApi.enhanceEndpoints({ addTagTypes: ["BusinessDetails"] }).injectEndpoints({
  endpoints: (builder) => ({
    getBusinessDetails: builder.query<GetBusinessDetailsResponse, void>({
      query: () => `/business-details`,
      transformResponse: transformBusinessDetails,
      providesTags: ["BusinessDetails"],
    }),
    updateBusinessDetails: builder.mutation<UpdateBusinessDetailsResponse, UpdateBusinessDetailsParams>({
      query: (body) => ({
        url: `/business-details`,
        method: "PUT",
        body: body,
      }),
      transformResponse: transformUpdateBusinessDetails,
      invalidatesTags: ["BusinessDetails"],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(onboardingApi.endpoints.getOnboardingStatus.initiate(undefined, { forceRefetch: true }));
        } catch {
          console.error("Failed to update business details");
        }
      },
    }),
  }),
});

export const { useGetBusinessDetailsQuery, useUpdateBusinessDetailsMutation } = businessDetailsApi;
